export default "__VITE_PUBLIC_ASSET__f551057a__"